import { types } from "../action-types";

const initialState = {
    loading: false,
    success: false,
};

const unFollowReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.POST_UNFOLLOW_REQUESTED:
            return {
                ...state,
                loading: true,
            };

        case types.POST_UNFOLLOW_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true
            };
        case types.POST_UNFOLLOW_FAILURE:
            return {
                ...state,
                loading: false,
            };

        default:
            return state;
    }
};

export default unFollowReducer;
